import { Box, LoadingOverlay } from '@mantine/core';

import type { ProductType, VendorAvailabilityListItem } from '../types';
import { useAvailability } from '../hooks/useAvailability';
import AvailabilityCalendarEmpty from './AvailabilityCalendar.empty';
import AvailabilityCalendarContent from './AvailabilityCalendar.content';
import dayjs from 'dayjs';

export type AvailabilityCalendarSectionProps = {
  vendorId: string;
  productType: ProductType;
  restaurant: VendorAvailabilityListItem;
  refetchAvailabilityList: () => void;
};

const AvailabilityCalendarSection: React.FC<AvailabilityCalendarSectionProps> = ({
  vendorId,
  productType,
  restaurant,
  refetchAvailabilityList,
}) => {
  const deadlineDate = restaurant.deadlineDate;
  const target = deadlineDate ? dayjs(deadlineDate).add(1, 'month') : null;

  const targetMonthNum = target ? target.month() + 1 : 0;
  const targetYear = target ? target.year() : 0;
  const targetMonth = target ? target.format('MMMM YYYY') : '';
  const { loading, data, refetch } = useAvailability({
    vendorId,
    productType,
    year: targetYear,
    month: targetMonthNum,
  });

  if (loading) {
    return (
      <Box mih={400} pos="relative">
        <LoadingOverlay visible />
      </Box>
    );
  }

  if (!data) {
    return <AvailabilityCalendarEmpty />;
  }

  return (
    <AvailabilityCalendarContent
      data={data}
      vendorId={vendorId}
      productType={productType}
      month={targetMonthNum}
      year={targetYear}
      restaurant={restaurant}
      refetch={refetch}
      targetMonth={targetMonth}
      refetchAvailabilityList={refetchAvailabilityList}
    />
  );
};

export default AvailabilityCalendarSection;
